export default "__VITE_ASSET__03cc0316__"